const CustomButtonOperator = (props) => {
  const { data } = props;
  const onEdit = props.context.onEdit;
  const onDelete = props.context.onDelete;
  const viewMode = props.context.viewMode; // "result" or "default"

  return (
    <div className="flex justify-center space-x-2">
      {viewMode === "result" ? (
        <>
          <button
            className="bg-warning text-white px-3 py-1 rounded text-sm"
            onClick={() => onDelete(data.mid, "View")}
          >
            View
          </button>
          <button
            className="bg-primary-400 text-white px-3 py-1 rounded text-sm"
            onClick={() => onDelete(data.mid, "Edit")}
          >
            Edit
          </button>
        </>
      ) : (
        <>
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded text-sm"
            onClick={() => onEdit(data)}
          >
            Edit
          </button>
        </>
      )}
    </div>
  );
};

export default CustomButtonOperator;
